import React from "react";
import MapStore from "./stores/mapStore";

const StoresContext = React.createContext({
  mapStore: new MapStore(),
});
export default StoresContext;
